module.exports = __webpack_public_path__ + "static/media/microsoft.d01b93df.svg";